// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2Nrgl","container":"styles_container__2ccII","title":"styles_title__25hM4","wrapper":"styles_wrapper__1bEza","answer":"styles_answer__1LHen"};